<div class="page-content-wrapper">
  <div class="card rounded-3 border-1 shadow">
    <ApplicationComponent />
  </div>
  <!-- Buttons -->
  <div class="text-end mt-4 mb-3">
    <button
      class="btn bg-green btn-sm text-xxs fw-bold rounded-small me-2"
      @click.prevent="approve_application">
      Approve
    </button>
    <button class="btn btn-danger btn-sm text-xxs fw-bold text-white rounded-small " @click.prevent="decline_application">Decline</button>
  </div>
</div>
